import { Fragment, useEffect } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon, XIcon, CheckIcon } from "@heroicons/react/solid";
import React, { useState } from "react";
import { Link } from "react-router-dom";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Dropdown(props) {
  const [selectedItemName, setSelectedItemName] = useState(props.title); // String shown in button of dropdown
  const [selectedItems, setSelectedItems] = useState([]); // only holds descriptions to display
  const [unSelectedItems, setUnselectedItems] = useState(props.items);
  const [propItems, setItems] = useState(props.items);
  const [displayItems, setDisplayItems] = useState(() => {
    return props.items;
  });

  // useEffect(() => {
  //   console.log("USE EFFECT run");
  //   console.log(selectedItems.length);
  //   resetSearch();
  // }, [selectedItems]);

  useEffect(() => {
    setDisplayItems(props.items);
    setUnselectedItems(props.items);
    return () => {
      setDisplayItems([]);
      setUnselectedItems([]);
    };
  }, [props.items]);

  function setCurrentItem(item) {
    //setSelectedItemName(item.description); // Name shows up where the title was
    // var arr = displayItems.filter((i) => i != item);
    //arr.sort((a, b) => a.description.localeCompare(b.description));
    //setDisplayItems(arr);

    let code = item.code.trim(); // getting code to be send to api if submit
    const selectedCodes = [...props.selectedCodes, code];
    props.current(selectedCodes); //This is the setState function of the parent. It is used to set the current selected item so it can be accessed in fetch call
    const selectedDescriptions = [...selectedItems, item];
    setSelectedItems(selectedDescriptions);
    setUnselectedItems(unSelectedItems.filter((i) => i != item));
  }

  function removeSelection(removeItem) {
    setSelectedItems(selectedItems.filter((item) => item !== removeItem));
    var arr = [...displayItems, removeItem];
    arr.sort((a, b) => a.description.localeCompare(b.description));
    setDisplayItems(arr);

    var unArr = [...unSelectedItems, removeItem];
    unArr.sort((a, b) => a.description.localeCompare(b.description));
    setUnselectedItems(unArr);
    let selectedCodes = [];
    let codes = selectedItems.filter((item) => item !== removeItem);

    for (var i = 0; i < codes.length; i++) {
      selectedCodes.push(codes[i].code.trim());
    }
    props.current(selectedCodes);
  }

  function filterFunction() {
    var input, filter, ul, li, a, i;

    input = document.getElementById("searchInput");
    filter = input.value.toUpperCase();

    setDisplayItems(
      unSelectedItems.filter((item) => item.description.includes(filter))
    );
  }

  function resetSearch() {
    let arr = [];
    let rmIndex = [];
    arr = [...props.items];
    for (let i = 0; i < arr.length; i++) {
      for (let j = 0; j < selectedItems.length; j++) {
        if (arr[i] == selectedItems[j]) {
          rmIndex.push(arr[i]);
        }
      }
    }
    for (let i = 0; i < rmIndex.length; i++) {
      arr = arr.filter((item) => item != rmIndex[i]);
    }

    setDisplayItems(arr);
  }

  var items = displayItems.map((item) => (
    <Menu.Item key={item.name}>
      {({ active }) => (
        <div
          className={classNames(
            active ? "bg-gray-100 text-gray-900" : "text-gray-700",
            "block px-4 py-2 text-sm cursor-pointer"
          )}
          onClick={() => setCurrentItem(item)}
        >
          {item.description}
        </div>
      )}
    </Menu.Item>
  ));
  return (
    <Menu
      as="div"
      className="relative inline-block text-left mt-2 m-auto "
      id={props.id}
      style={{ zIndex: props.z }}
      onBlur={() => {
        setTimeout(() => {
          resetSearch();
        }, 500);
      }}
    >
      {({ open }) => (
        <div>
          <div>
            <Menu.Button className="inline-flex justify-center w-56 rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-600">
              {props.title}
              <div
                className="pl-1 inline-flex"
                style={{ display: selectedItems.length == 0 ? "none" : "" }}
              >
                <CheckIcon className="w-5 h-5 fill-current text-green-500" />
                {selectedItems.length}
              </div>
              <ChevronDownIcon
                className="-mr-1 ml-2 h-5 w-5"
                aria-hidden="true"
              />
            </Menu.Button>
          </div>

          <Transition
            show={open}
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              static
              className="origin-top-right absolute h-56 overflow-auto mt-2 w-full rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
            >
              <input
                type="text"
                className=" w-full rounded-md text-sm shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                placeholder="Search.."
                id="searchInput"
                autocomplete="off"
                onKeyUp={filterFunction}
              ></input>
              <div
                className=""
                onMouseDown={(e) => {
                  return;
                }}
              >
                {selectedItems.map((item) => (
                  <Menu.Item>
                    {({ active }) => (
                      <div
                        className={classNames(
                          active
                            ? "bg-gray-100 text-gray-900"
                            : "bg-gray-100 text-gray-700",
                          "block px-4 py-2 text-sm m-1"
                        )}
                        onClick={() => resetSearch()}
                      >
                        <div className="grid grid-cols-4">
                          <div className="col-span-3">{item.description}</div>

                          <div
                            className="col-span-1"
                            onClick={() => removeSelection(item)}
                          >
                            <XIcon className="h-5 w-5 m-auto cursor-pointer" />
                          </div>
                        </div>
                      </div>
                    )}
                  </Menu.Item>
                ))}
              </div>
              <div className="py-1">{items}</div>
            </Menu.Items>
          </Transition>
        </div>
      )}
    </Menu>
  );
}
